import { coreService } from "../../services/coreService";
import { buildQuery } from "../../lib/network";

export type PutCrmCustomListViewParamsType = Parameters<(typeof coreService)["crmSearchDemoViewsUpdate"]>[1];

export const putCrmCustomListView =
  (headers: any) =>
  ({ id, body }: { id: number; body: PutCrmCustomListViewParamsType }) => {
    return buildQuery(coreService.crmSearchDemoViewsUpdate(id, body, { headers }), (response) => {
      return response.data;
    });
  };
